// import React, { useState, useEffect } from "react";
import classes from './Header.module.css';

const Header = () => {


    return (
        <>
            {/* <img src="/images/header.png" /> */}
            <div className={classes.header_container}>

                <div className={classes.hero_section}>
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className={classes.title_block}>
                                <h4 className={classes.hero_title}>DTM IDPs Baseline Visualizer</h4>
                                <p className={classes.hero_subtext}>A text based way to access, analyse and visualise DTM IDP Baseline data</p>
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-6">
                            <div className={classes.right_links}>
                                <a rel="noreferrer" target="_blank" href="https://dtm.iom.int/data-and-analysis/dtm-api" className={`${classes.link} ${classes.right_link}`}>
                                    <img alt="" className={classes.visualizer_side_right_image} src="/images/documentation.png" />
                                    <div className={classes.right_link_text}>
                                        <p className={classes.visualizer_side_right}>Documentation</p>
                                    </div>
                                </a>
                                <a rel="noreferrer" target="_blank" href="https://dtm.iom.int/data-and-analysis/dtm-api/data-coverage" className={`${classes.link} ${classes.right_link}`}>
                                    <img alt="" className={classes.visualizer_side_right_image} src="/images/data_coverage.png" />
                                    <div className={classes.right_link_text}>
                                        <p className={classes.visualizer_side_right}>Data Coverage</p>
                                    </div>
                                </a>
                                <a rel="noreferrer"target="_blank" href="https://dtm.iom.int/data-and-analysis/dtm-api/data-coverage/app/data-coverage/index.html?openModal" className={`${classes.link} ${classes.right_link}`}>
                                    <img alt="" className={classes.visualizer_side_right_image} src="/images/query_builder.png" />
                                    <div className={classes.right_link_text}>
                                        <p className={classes.visualizer_side_right}>Query Builder</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>


                </div >
            </div>

            {/* <div className={classes.aggregated_figures}>
                <div className="container">
                    <h4 className={classes.aggregated_figures_title}>Internally Displaced Population Tracked by DTM — Regional Overview 2025</h4>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="row">
                                <div className="col-md-2">
                                    <img className={classes.visualizer_side_right_image} src="/images/total_idps.png" />
                                </div>
                                <div className="col-md-10">
                                    <p className={classes.aggregated_figures_figure_text}>Total IDPs</p>
                                    <p className={classes.aggregated_figures_figure}>25,457,168</p>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-3">
                            <div className="row">
                                <div className="col-md-2">
                                    <img className={classes.visualizer_side_right_image} src="/images/countries.png" />
                                </div>
                                <div className="col-md-10">
                                    <p className={classes.aggregated_figures_figure_text}>Countries & Territories</p>
                                    <p className={classes.aggregated_figures_figure}>189</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default Header
